import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
const ProtectedRoute = ({ children, requiredSubscription }) => {
    const { user, isLoading, isAuthenticated } = useAuth();
    const location = useLocation();
    if (isLoading) {
        return (_jsxs("div", { className: "loading-spinner", children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Loading..." })] }));
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    if (requiredSubscription && user) {
        const subscriptionLevels = { free: 0, premium: 1, elite: 2 };
        const userLevel = subscriptionLevels[user.subscriptionTier] || 0;
        const requiredLevel = subscriptionLevels[requiredSubscription] || 0;
        if (userLevel < requiredLevel) {
            return (_jsxs("div", { className: "subscription-required", children: [_jsx("h2", { children: "Subscription Required" }), _jsxs("p", { children: ["This feature requires a ", requiredSubscription, " subscription."] }), _jsx("button", { onClick: () => window.location.href = '/profile', children: "Upgrade Subscription" })] }));
        }
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
